<!-- todo: register as a global component -->
<template>
    <component
        :is="href ? 'a' : 'button'"
        :class="['ep-btn', `ep-btn-${variant}`, sizeClass, expandClass, disabledClass, loadingClass, pulseClass]"
        v-bind="$attrs"
        :disabled="internalDisabled"
        :type="href ? null : type"
        :href="href ? href : null"
        :target="href ? target : null"
        :download="href ? download : null"
        :name="name"
        :value="value"
    >
        <span class="flex gap-4 items-center" :class="invisibleClass" v-tooltip="tooltip">
            <i v-if="startIcon" :class="`${iconFamily} fa-${startIcon}`"></i>

            <span
                v-if="$slots.default"
                class="whitespace-normal"
                :class="textClass"
            >
                <slot></slot>
            </span>

            <slot name="append">
                <i v-if="endIcon" :class="`fa fa-${endIcon}`"></i>
            </slot>
        </span>

        <ep-spinner
            v-if="loading"
            class="absolute"
            :is-dark="variant === 'secondary' || variant === 'tertiary'"
        />
    </component>
</template>

<script>
import EpSpinner from '@/system/components/global/spinner';

export default {
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    name: 'EpButton',
    components: { EpSpinner },
    props: {
        href: {
            type: String,
            default: null,
        },

        variant: {
            default: 'primary',
            type: String,
            validator: value => ['primary', 'secondary', 'tertiary', 'danger', 'white'].includes(value),
        },

        size: {
            default: 'md',
            type: String,
            validator: value => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value),
        },

        expand: {
            default: false,
            type: Boolean,
        },

        disabled: {
            default: false,
            type: Boolean,
        },

        loading: {
            default: false,
            type: Boolean,
        },

        iconFamily: {
            default: 'fa',
            type: String,
        },

        startIcon: {
            default: null, // use font awesome icons
            type: String,
        },

        endIcon: {
            default: null, // use font awesome icons
            type: String,
        },

        pulse: {
            default: false,
            type: Boolean,
        },

        type: {
            type: String,
            default: 'button',
            validator: value => ['button', 'submit', 'reset'].includes(value),
        },

        target: {
            type: String,
            default: '_self',
            validator: value => ['_self', '_blank', '_parent', '_top'].includes(value),
        },

        download: {
            type: Boolean,
            default: false,
        },

        name: {
            type: String,
            default: null,
        },

        value: {
            type: String,
            default: null,
        },

        tooltip: {
            type: String,
            default: null,
        }
    },

    computed: {
        sizeClass () {
            return this.size === 'md' ? '' : `ep-btn-${this.size}`
        },

        expandClass () {
            return this.expand ? 'ep-btn-expand' : '';
        },

        internalDisabled() {
            // Also disable the button if loading, in order to prevent double-clicks => prevent double requests
            return this.disabled || this.loading;
        },

        disabledClass () {
            return this.disabled ? 'disabled' : '';
        },

        loadingClass () {
            return this.loading ? 'loading' : '';
        },

        // todo: the css and animation for pulse if defined globally, if we plan to ever build a UI Library out of the ui components, we should move the css to the library.
        pulseClass () {
            return this.pulse ? 'pulse' : '';
        },

        invisibleClass () {
            return this.loading ? 'invisible' : '';
        },

        textClass () {
            return this.startIcon || this.endIcon ? 'text-left' : '';
        }
    },
}
</script>
